export const environment = {
  production: true,
  appBaseUrl: 'https://ferreira-auto.onrender.com',
  apiBasePath: '/api',
  apiBaseUrl: 'https://auto-1-k9gu.onrender.com'
};